import { Level } from "../modals/stock-levels-model/stock-levels-modal.component";

//TODO: change this name to findLevelNameByZ
export function findCrateLevel(z, levels) {
  if (z < 0 || !levels.length) {
    return "indefinido";
  }
  
  const validLevels = levels.filter(l => !l.isTenantLevel);
  if (!validLevels.length) return '---';

  const level = levels.reduce((closestLevel, currentLevel) =>
    Math.abs(z - closestLevel.reference) < Math.abs(z - currentLevel.reference) ? closestLevel : currentLevel
  );
  return level.name.length ? level.name : '---';
}


export function findLevelByZ(z: number, levels: (Level & {isTenantLevel: boolean})[]): Level|null {
  if (z < 0 || !levels.length) {
    return null;
  }

  const validLevels = levels.filter(l => !l.isTenantLevel);
  if (!validLevels.length) return null;

  const level = levels.reduce((closestLevel, currentLevel) =>
    Math.abs(z - closestLevel.reference) < Math.abs(z - currentLevel.reference) ? closestLevel : currentLevel
  );
  return level;
}
